import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Delete, Edit } from '@mui/icons-material';

import { useGlobal } from './../../hooks/useGlobal';
import { useCobranca } from '../../hooks/useCobranca';
import useWindow from '../../hooks/windowSet';
import api from '../../services/api';
import { formatFormDate, formatToLocaleCurrency, formatToLocaleDate } from '../../util/formats';
import { selecionarStatus } from '../../helper/tratarStatusCobranca';

import Status from '../Status';
import BotaoComIcone from '../Botao/BotaoComIcone';
import Modal from '../Modal/index';
import ModalIdCobranca from '../../components/ExcluirCobrancaModal';
import CobrancaFormEditar from '../../components/EditarCobrancaModal';

const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 2fr;
`;

const TableCellStyled = styled.span`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.005em;
  padding: 1px;
  color: #3F3F55;
  text-transform: capitalize;  
  white-space: nowrap; 
  border: 50px;
`;

const TableCellConteudo = styled.span`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 40px;
  letter-spacing: 0.005em;
  padding: 1px;
  border-top: 1px solid #EFF0F6;
  color: #747488;
`;

const DescricaoText = styled.p`
  white-space: nowrap;
  width: 348px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Descricao = styled.div`
  display: flex;    
  gap: 24px;
`;

/* const dados = [
  {
    id: 0,
    vencimento: '2021-01-26',
    valor: 50000,
    status: 'Pendente',
    descricao: 'lorem ipsum  lorem ipsum lorem ipsuipsum lorem ips'
  },
  {
    id: 1,
    vencimento: '2025-01-26',
    valor: 75300,
    status: 'Pendente',
    descricao: 'lorem ipsum  lorem ipsum lorem ipsuipsum lorem ips'
  },
  {
    id: 2,
    vencimento: '2021-01-26',
    valor: 150000,
    status: 'Paga',
    descricao: 'lorem ipsum  lorem ipsum lorem ipsuipsum lorem ips'
  },
]; */

export default function TabelaCobrancaCliente() {
  /* const [cobrancasCliente, setCobrancasCliente] = useState([]); */
  const { clienteSelecionado, token } = useGlobal();
  const { cobrancas, setCobrancas, setIdCobranca } = useCobranca();
  const [openConfirm, setOpenDelete] = useState(false);
  const [open, onClose, onOpen] = useWindow();
  const [textModal, setTextModal] = useState({});

  useEffect(() => {
    /* setCobrancasCliente(dados); */

    const config = {
      headers: { Authorization: `Bearer ${token}` }
    };

    try {
      const ListarCobrancasCliente = async () => {
        return await api.get(`/cobrancas/${clienteSelecionado.id}`, config);
      };

      ListarCobrancasCliente().then(({ data: listaCobrancasDeCliente }) => {
        setCobrancas([...listaCobrancasDeCliente]);
      });
    } catch (e) {
      console.error('erro>', e);
      setCobrancas([]);
    }
  }, []);

  function handleOpenModalEditar(e, id) {
    e.preventDefault();

    const temp = cobrancas[id];
    const localCobrancaEditar = { ...temp };

    localCobrancaEditar.valor = (localCobrancaEditar.valor / 100);
    localCobrancaEditar.vencimento = formatFormDate(localCobrancaEditar.vencimento);

    setTextModal(localCobrancaEditar);
    onOpen();
  };

  function handleDeleteModal(id) {
    setIdCobranca(id);
    setOpenDelete(true);
  };

  return (
    <>
      <Table key='Cliente Table'>
        <TableCellStyled key={0} align='left'>ID cob.</TableCellStyled>
        <TableCellStyled key={1} align='left'>Data de venc.</TableCellStyled>
        <TableCellStyled key={2} align='left'>valor</TableCellStyled>
        <TableCellStyled key={3} align='left'>status</TableCellStyled>
        <TableCellStyled key={4} align='left'>descrição</TableCellStyled>

        {cobrancas.map((row, index) => (
          <>
            <TableCellConteudo key={index + row.id} component='th' scope='row' >
              {row.id}
            </TableCellConteudo>

            <TableCellConteudo key={index + row.vencimento} component='th' scope='row' align='left'>
              {formatToLocaleDate(row.vencimento)}
            </TableCellConteudo>

            <TableCellConteudo key={index + row.valor} align='left'>
              {formatToLocaleCurrency(row.valor)}
            </TableCellConteudo>

            <TableCellConteudo key={index + row.status} align='left'>
              <Status statusIndex={selecionarStatus(row.status, row.vencimento)} cobranca={true} />
            </TableCellConteudo>

            <TableCellConteudo key={index + row.descricao} align='left'>
              <Descricao>
                <DescricaoText>{row.descricao}</DescricaoText>

                <BotaoComIcone
                  Icon={Edit}
                  text='editar'
                  colorIcon='#747488'
                  onClick={e => handleOpenModalEditar(e, index)}
                />
                <BotaoComIcone
                  Icon={Delete}
                  text='excluir'
                  colorIcon='#AE1100'
                  onClick={() => handleDeleteModal(row.id)}
                />
              </Descricao>
            </TableCellConteudo>
          </>
        ))}
      </Table>

      {openConfirm &&
        <ModalIdCobranca
          setOpenDelete={setOpenDelete}
        />
      }

      {open &&
        <Modal close={onClose}>
          <CobrancaFormEditar
            onClose={onClose}
            textEdit={textModal}
          />
        </Modal>
      }
    </>
  );
};
